export const defaultOrderBy = 'traffic';
export const defaultOrderDir = 'desc';
